// Ideally we would dynamically import the scss dependent on if the company is
// motherlode or not. Since these files are relatively small, we import both.
import './sass/config-sps.scss';
import './sass/config-ml.scss';

import { Application, EventHandler } from 'app/classes';
import { BannerService } from 'app/services/banner.service/banner.service';
import { $LaunchDarklyService } from 'app/services/launch-darkly.service/launch-darkly.service';

const OPENED = 'opened';
const CLOSED = 'closed';

export class NgCtrl {
  public static $inject = [
    '$scope',
    '$rootScope',
    '$timeout',
    '$Router',
    '$CurrentUser',
    'DropdownManagerService',
    '$translate',
    '$Window',
    'SubscriptionWarningModal',
    'TokenCheck'
  ];

  public ddState;
  public showExtraNav;
  public timeZoneInfo;
  public currentApp: Application;
  public showBanner: boolean;
  public phone: string;
  public option: string;
  public showNotifications: boolean;
  public showIntercom: boolean;
  public isAPAC: boolean;

  constructor(
    private $scope,
    private $rootScope,
    private $timeout,
    private $Router,
    private $CurrentUser,
    private DropdownManagerService,
    private $translate,
    private $Window,
    private SubscriptionWarningModal,
    private TokenCheck
  ) {
    this.ddState = DropdownManagerService.state;
    const openNgDropdown: Event = new CustomEvent('openNgDropdown');
    this.showNotifications = false;
    this.showIntercom = false;

    $CurrentUser.onLogin(() => {
      TokenCheck.start();
      // Now that we have a user, initialize Launch Darkly
      $LaunchDarklyService.init($CurrentUser)
        .then(() => {
          // once we have successfully initialized, we'll set up a ready listener
          $LaunchDarklyService.ldclient.on("ready", () => {
            // now that we're ready, let's set the feature flags on the nav
            $scope.$applyAsync(() => {
              this.showNotifications = $LaunchDarklyService.userFeatures.webChannelDisplay;
              this.showIntercom = $LaunchDarklyService.userFeatures.intercomIntegration;
            });
          });
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.showExtraNav = true;
          // ensure we can detect future launch darkly changes
          $LaunchDarklyService.ldclient.on('change', () => {
            $scope.$applyAsync(() => {
              this.showNotifications = $LaunchDarklyService.userFeatures.webChannelDisplay;
              this.showIntercom = $LaunchDarklyService.userFeatures.intercomIntegration;
            });
          });
        });
    }, true);
    this.setBannerProperties();
    this.handleLaunchAppWarningModalEvent();

    this.$Window.onLocationChange(() => {
      const cpCurrentApplication = this.$Router.getCurrentApplication();
      if (this.currentApp !== cpCurrentApplication) {
        this.setBannerProperties();
        $scope.$apply();
      }
    });

    $CurrentUser.onLogout(() => {
      TokenCheck.stop();
      $scope.$applyAsync(() => {
        this.showExtraNav = false;
      });
    }, true);
    $scope.$watch(
      () => {
        return $LaunchDarklyService.userFeatures.webChannelDisplay;
      },
      (val, oldVal) => {
        if (val !== oldVal) {
          this.showNotifications = val;
        }
      }
    );
    $scope.$watch(
      () => {
        return $LaunchDarklyService.userFeatures.intercomIntegration;
      },
      (val, oldVal) => {
        if (val !== oldVal) {
          this.showIntercom = val;
        }
      }
    );
    $scope.$watch(
      () => {
        return this.ddState;
      },
      (val, oldVal) => {
        if (val.profileDropdown === OPENED && oldVal.appSwitcher === OPENED) {
          dispatchEvent(openNgDropdown);
          this.ddState.appSwitcher = CLOSED;
        }
        if (val.appSwitcher === OPENED && oldVal.profileDropdown === OPENED) {
          dispatchEvent(openNgDropdown);
          this.ddState.profileDropdown = CLOSED;
        }
        if (val.appSwitcher === OPENED || val.profileDropdown === OPENED) {
          dispatchEvent(openNgDropdown);
        }
      },
      true
    );

    $rootScope.$on('$translateLoadingError', (e, data) => {
      if (data.language !== 'en-US') {
        /* tslint:disable-next-line:no-console */
        console.warn(
          'translation error; unable to find language file for:',
          data.language
        );
        $translate.use('en-US');
        if (window.Raven) {
          window.Raven.captureMessage('unexpected language format', data);
        }
      } else {
        /* tslint:disable-next-line:no-console */
        console.error('unable to load English language file');
        window.Raven.captureException(
          new Error('Unable to load English language file')
        );
      }
    });
  }

  public goToLaunchpad = (event, path) => {
    // metaKey for Mac and ctrlKey for PC and shiftKey for opening new window
    const openInNewTab = event.metaKey || event.ctrlKey || event.shiftKey;
    if (openInNewTab) {
      return;
    }
    event.preventDefault();
    this.$Router.goto(`/launchpad/${path}/`);
  };

  private setBannerProperties = () => {
    this.currentApp = this.$Router.getCurrentApplication();
    this.phone = this.currentApp?.subscription?.acctServPhoneNumber;
    this.option = this.currentApp?.subscription?.acctPhoneOption;
    this.isAPAC = this.currentApp?.subscription?.acctIsAPAC;
    this.showBanner =
      this.currentApp?.subscription?.status === 'suspension-warning';

    (this.showBanner && (this.phone || this.isAPAC) ? BannerService.show : BannerService.hide)();
  };

  private handleLaunchAppWarningModalEvent = () => {
    const elem = document.body;
    elem.addEventListener('launchAppWarningModal', () => {
      const transitionApp = this.$Router.getTransitioningApplication();
      const status = transitionApp?.subscription?.status;
      const acctServMessage = transitionApp?.subscription?.acctServMessage;
      const phone = transitionApp?.subscription?.acctServPhoneNumber;
      if (status && acctServMessage && (phone || this.isAPAC)) {
        this.SubscriptionWarningModal.show({ acctServMessage, phone, status });
      }
    });
  };
}
